var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7587 1.11366C23.0821 1.42851 23.0821 1.94647 22.7587 2.26132L8.79442 16.0738C8.47612 16.3937 7.95246 16.3937 7.63415 16.0738L0.240576 8.76132C-0.080192 8.44648 -0.080192 7.92851 0.240576 7.61366C0.561138 7.29374 1.08121 7.29374 1.40208 7.61366L8.21429 14.3523L21.5984 1.11366C21.9167 0.795771 22.4404 0.795771 22.7587 1.11366Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.8a9c62b19f955668b6bde8079dacbebd.svg";
export { ForwardRef as ReactComponent };